<template>
  <div class="IperMatrizPeligrosDescargarExcelAdmin">
    <div class="text-left">
      <button class="btn boton_guardar1 mt-3" data-toggle="modal" data-target="#descargarexcelAdmin"  style="width: 180px !important"
        @click="obtenerUsuarios()" :disabled="cargandoTemp">
        Ver Registros
      </button>
    </div>

    <!-- MODAL DESCARGAR EXCEL ADMINISTRADOR -->
    <div class="modal modal-fullscreen fade" id="descargarexcelAdmin" data-backdrop="static" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content bg-light">
          <div class="modal-header">
            <h5 class="modal-title titulos" id="exampleModalLabel">
              Lista de Clientes
            </h5>
            <button class="close" data-dismiss="modal" type="button" aria-label="Close">
              <span aria-hidden="true" style="font-size: 30pt;">&times;</span>
            </button>
          </div>
          <div class="row">
            <div class="col-md-12 mb-3">
              <a class="btn btn-success mt-3 ml-4" id="testAdmin" type="button" href="javascript:void(0)"
                @click="descargarExcel()">
                Descargar Excel
              </a>
            </div>
          </div>
          <div class="modal-body">
            <table class="table table-bordered" id="myTableAdmin">
              <thead class="tabla">
                <tr>
                  <th scope="col">
                    Puesto de Trabajo
                  </th>
                  <th scope="col">
                    Nit
                  </th>
                  <th scope="col">
                    Ciudad
                  </th>
                  <th scope="col">
                    Regional
                  </th>
                  <th scope="col">
                    Número de Expuestos
                  </th>
                  <th scope="col">
                    Cant. de Peligros
                  </th>
                  <th scope="col">
                    Elaborado Por
                  </th>
                  <th scope="col">
                    Dirección
                  </th>
                  <th scope="col">
                    Fecha de Actualización
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) of registrosTemp" :key="index">
                  <td>{{ item.centroTrabajo }}</td>
                  <td>{{ item.nit }}</td>
                  <td>{{ item.ciudad }}</td>
                  <td>{{ item.regional }}</td>
                  <td>{{ item.numeroTrabajadores }}</td>
                  <td>{{ item.cantidadPeligros }}</td>
                  <td>
                    <template v-if="item.responsable">
                      {{ item.responsable }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                  <td>{{ item.direccion }}</td>
                  <td>{{ item.fechaActualizacion }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebase";
export default {
  name: "IperMatrizPeligrosDescargarExcelAdmin",

  props: {
    registros: Array,
    cargando: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      registrosTemp: JSON.parse(JSON.stringify(this.registros)),
      cargandoTemp: JSON.parse(JSON.stringify(this.cargando)),
    };
  },

  watch: {
    registros() {
      this.registrosTemp = JSON.parse(JSON.stringify(this.registros));
      // console.log(this.registrosTemp);
    },

    cargando() {
      this.cargandoTemp = JSON.parse(JSON.stringify(this.cargando));
    }
  },

  methods: {
    async obtenerUsuarios() {
      this.$isLoading(true);
      let registros = JSON.parse(JSON.stringify(this.registrosTemp));
      let usuarios = await Promise.all(
        registros.map(async (item) => {
          return await this.obtenerUsuario(item);

        })
      );
      this.registrosTemp = usuarios;
      this.$isLoading(false);
    },

    async obtenerUsuario(item) {
      let usuario = item.em_registrado_por;
      let nit = null;
      if (!item.em_registrado_por) {
        usuario = "IPER ANTIGUO";
      } else {
        await db
          .collection("usuarios")
          .where("u_correo", "==", item.em_registrado_por)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (item.em_registrado_por.includes("@sofu")) {
                    usuario = "SOFU BIC S.A.S"
                } else {
                    usuario = `${doc.data().u_nombre_usuario} ${doc.data().u_apellido}`
                }
            });
          });
      }
      if (item.empresa.id == "" || item.empresa.id == null) {
        nit = ""
      } else {
        await db
          .collection("cliente_principal")
          .doc(item.empresa.id)
          .get()
          .then((doc) => {
            if (doc.exists) {
              nit = doc.data().cl_nit_cliente;
            }
          });
      }
      return {
        ...item,
        responsable: usuario,
        nit: nit,
      };
    },

    descargarExcel() {
      var tab_text =
        '<html xmlns:o="urn:schemas-microsoft-com:office:excel" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40" <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">>';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Matrices de Riesgo</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='0px !important;'>";
      tab_text = tab_text + $("#myTableAdmin").html();
      tab_text = tab_text + "</table></body></html>";
      var data_type = 'data:application/vnd.ms-excel;base64"';
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        if (window.navigator.msSaveBlob) {
          var blob = new Blob([tab_text], {
            type: "application/csv;",
          });
          navigator.msSaveBlob(blob, "Matrices.xls");
        }
      } else {
        $("#testAdmin").attr(
          "href",
          data_type + ", " + encodeURIComponent(tab_text)
        );
        $("#testAdmin").attr("download", "Matrices.xls");
      }
    },
  },
};
</script>

<style scoped>
button {
  width: 100px;
}

th,
td {
  border: black 1px solid !important;
}

.modal.modal-fullscreen .modal-dialog {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  max-width: none;
}

.modal.modal-fullscreen .modal-content {
  height: auto;
  height: 100vh;
  border-radius: 0;
  border: none;
}

.modal.modal-fullscreen .modal-body {
  overflow-y: auto;
}
</style>